import { getSlateSpacingPixelsString } from "@faire/retailer-shared/SlateMappings/getSlateSpacingPixels";
import { convertServerResponsivePropertyToClientResponsiveProperty } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/responsiveValues";
import { ResponsiveValues } from "@faire/web--source/slate/Theme/ResponsiveValues";
import { IResponsiveSpacing } from "@faire/web-api--source/indigofair/data/IResponsiveSpacing";
import { Spacing } from "@faire/web-api--source/indigofair/data/Spacing";

export type ResponsiveSpacingPixels = ResponsiveValues<string>;

export const getResponsiveSpacingPixels = (
  defaultSpacing: keyof typeof Spacing = Spacing.SPACING_NONE,
  responsiveSpacing?: IResponsiveSpacing
): ResponsiveSpacingPixels => {
  return convertServerResponsivePropertyToClientResponsiveProperty(
    defaultSpacing,
    (value: keyof typeof Spacing) => getSlateSpacingPixelsString(value),
    responsiveSpacing
  );
};

// eslint-disable-next-line complexity
export const getConsolidatedSpacingValues = (
  topSpacing: ResponsiveSpacingPixels,
  bottomSpacing: ResponsiveSpacingPixels,
  leftSpacing: ResponsiveSpacingPixels,
  rightSpacing: ResponsiveSpacingPixels
): ResponsiveSpacingPixels => {
  const consolidatedSpacingValues: ResponsiveSpacingPixels = {
    mobileAndAbove: `${topSpacing.mobileAndAbove} ${rightSpacing.mobileAndAbove} ${bottomSpacing.mobileAndAbove} ${leftSpacing.mobileAndAbove}`,
  };
  if (
    topSpacing.tabletAndAbove ||
    rightSpacing.tabletAndAbove ||
    bottomSpacing.tabletAndAbove ||
    leftSpacing.tabletAndAbove
  ) {
    consolidatedSpacingValues.tabletAndAbove = `${
      topSpacing.tabletAndAbove ?? topSpacing.mobileAndAbove
    } ${rightSpacing.tabletAndAbove ?? rightSpacing.mobileAndAbove} ${
      bottomSpacing.tabletAndAbove ?? bottomSpacing.mobileAndAbove
    } ${leftSpacing.tabletAndAbove ?? leftSpacing.mobileAndAbove}`;
  }
  if (
    topSpacing.desktopAndAbove ||
    rightSpacing.desktopAndAbove ||
    bottomSpacing.desktopAndAbove ||
    leftSpacing.desktopAndAbove
  ) {
    consolidatedSpacingValues.desktopAndAbove = `${
      topSpacing.desktopAndAbove ??
      topSpacing.tabletAndAbove ??
      topSpacing.mobileAndAbove
    } ${
      rightSpacing.desktopAndAbove ??
      rightSpacing.tabletAndAbove ??
      rightSpacing.mobileAndAbove
    } ${
      bottomSpacing.desktopAndAbove ??
      bottomSpacing.tabletAndAbove ??
      bottomSpacing.mobileAndAbove
    } ${
      leftSpacing.desktopAndAbove ??
      leftSpacing.tabletAndAbove ??
      leftSpacing.mobileAndAbove
    }`;
  }
  return consolidatedSpacingValues;
};
